const cookiesService = {
    get (name) {
        const cookie = {};
        document.cookie.split(';').forEach(function (el) {
            const [k, v] = el.split('=');
            cookie[k.trim()] = v;
        });
        return cookie[name];
    },
    set (name, value, options) {
        options = options || {};

        let expires = options.expires;

        if (typeof expires === 'number' && expires) {
            const d = new Date();
            d.setTime(d.getTime() + expires * 1000);
            expires = options.expires = d;
        }
        if (expires && expires.toUTCString) {
            options.expires = expires.toUTCString();
        }

        value = encodeURIComponent(value);

        let updatedCookie = name + '=' + value;

        for (const propName in options) {
            updatedCookie += '; ' + propName;
            const propValue = options[propName];
            if (propValue !== true) {
                updatedCookie += '=' + propValue;
            }
        }

        document.cookie = updatedCookie;
    },
    delete (name) {
        document.cookie = name + '=; Path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT;';
    }
};

export default cookiesService;
